// 登录页（Task 16.1）—— 用 captcha-console /api/v1/auth/login 接口。
//
// MVP 限定：仅邮箱+密码；TOTP / OAuth 由 console 后端 stub，先放后续 V1。

import { useState } from 'react';
import { login } from '../lib/api';
import { writeSession } from '../lib/storage';
import { navigate } from '../lib/route';

export function Login(): JSX.Element {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const res = await login(email, password);
      if ('requires_totp' in res) {
        setErr('TOTP required — V1 在控制台中接管');
        return;
      }
      writeSession({ token: res.jwt, email, role: 'owner' });
      navigate('sites');
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : 'login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 360, margin: '80px auto', padding: '0 16px' }}>
      <h1 style={{ fontSize: 22 }}>Captcha SaaS Console</h1>
      <form onSubmit={onSubmit}>
        <label style={{ display: 'block', marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: '#475569', marginBottom: 4 }}>邮箱</div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
        </label>
        <label style={{ display: 'block', marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: '#475569', marginBottom: 4 }}>密码</div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
        </label>
        <button type="submit" disabled={busy} style={btnStyle}>
          {busy ? '登录中…' : '登录'}
        </button>
        {err && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              fontSize: 12,
              color: '#991b1b',
              background: '#fee2e2',
              borderRadius: 6,
            }}
          >
            {err}
          </div>
        )}
      </form>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #cbd5e1',
  borderRadius: 6,
  fontSize: 14,
  boxSizing: 'border-box',
};
const btnStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 14px',
  background: '#2563eb',
  color: 'white',
  border: 0,
  borderRadius: 6,
  fontSize: 14,
  cursor: 'pointer',
};
